/* src/app/components/doc-viewer-new/doc-viewer-content/doc-viewer-redaction-content/draw-box/draw-box.component.scss */
.draw-box {
  position: absolute;
  z-index: 1;
  cursor: move;
}
.draw-box canvas {
  width: 100%;
  height: 100%;
}
.draw-box .draw-box-text {
  cursor: move;
}
.draw-box .draw-box-handle {
  width: 30px;
  height: 30px;
  background: red;
}
.draw-box .draw-box-handle .top-right {
  left: 100%;
}
/*# sourceMappingURL=draw-box.component.css.map */
